import { trackInAdobe } from './service/adobe.js';

const trackEvent = (event) => {
    if (window) {
        trackInAdobe(event);
    }
};

export { trackEvent };
//# sourceMappingURL=index.js.map
